import { jsx as _jsx } from "react/jsx-runtime";
import { LocaleFormatter } from '@awaze/mfe-common.locale-formatting';
import { TranslationsProvider } from './translations-context-provider';
import { CombinedProvider } from './combined-context-provider';
const deriveCurrencySymbol = (language, currency) => {
    const currencyParts = new Intl.NumberFormat(language, {
        style: 'currency',
        currency,
    }).formatToParts();
    return currencyParts.find((p) => p.type === 'currency')?.value || currency;
};
export const IntlProvider = ({ children, currency, language, country, translations, }) => {
    const { formatCurrency, formatCurrencyToObject } = new LocaleFormatter(language, currency);
    const currencySymbol = deriveCurrencySymbol(language, currency);
    return (
    // TODO: We need to upgrade to React 18
    // @ts-ignore
    _jsx(TranslationsProvider, { language: language, translations: translations, render: () => (
        // TODO: We need to upgrade to React 18
        // @ts-ignore
        _jsx(CombinedProvider, { language: language, country: country, formatCurrency: formatCurrency, formatCurrencyToObject: formatCurrencyToObject, currencySymbol: currencySymbol, children: children })), children: children }));
};
//# sourceMappingURL=intl-context-provider.js.map